import * as React from 'react'
import { StyledButton } from './Button.styled'

export interface ButtonProps {
  fontWeight?: string
  className?: string
  hover?: boolean
  submit?: boolean
  color?: string
  children?: React.ReactNode
  onClick?: (e?: React.MouseEvent) => void
  style?: React.CSSProperties
}

export const ButtonStorybook: React.FC<ButtonProps> = ({
  color,
  submit,
  children,
  ...props
}) => (
  <StyledButton
    type={submit ? 'submit' : 'button'}
    // @ts-ignore
    color={color}
    className={`btn__${color}`}
    {...props}
  >
    {children}
  </StyledButton>
)
